import { PsResourceCompany } from '../../shared/model/resource/PsResourceCompany';
import { PsResourceDocumentation } from '../../shared/model/resource/PsResourceDocumentation';
import MachineContractorState from '../../shared/model/MachineContractorState';
import MachineState from '../../shared/model/MachineState';

export class PsMachine {

    _id; // number
    _model; // string
    _brand; // string
    _active; // boolean
    _company; // PsResourceCompany
    _description; // string
    _licensePlate; // string
    _documentation; // PsResourceDocumentation

    constructor(
        id,
        model,
        brand,
        active,
        company,
        description,
        licensePlate,
        documentation,
    ) {
        this._id = id;
        this._model = model;
        this._brand = brand;
        this._active = active;
        this._company = company;
        this._description = description;
        this._licensePlate = licensePlate;
        this._documentation = documentation;
    }

    static fromAPIMachines(machines, currentUser) {
        return machines.map((machine) => PsMachine.fromAPIMachine(machine, currentUser));
    }

    static fromAPIMachine(machine, currentUser) {
        const { machine_documentation_state: state } = machine;
        let active;
        if (machine.machine_contractor_state) {
            active = machine.machine_contractor_state.id === MachineContractorState.ACTIVE;
        } else {
            active =  machine.machine_state.id === MachineState.ACTIVE;
        }

        return new this(
            machine.id,
            machine.model || '',
            machine.brand || '',
            active,
            machine.company ? PsResourceCompany.fromAPICompany(machine.company) : PsResourceCompany.null(),
            machine.notes || '',
            machine.name || '',
            PsResourceDocumentation.fromAPIOutsourceResource(currentUser, machine, state),
        );
    }

    id() {
        return this._id;
    }

    model() {
        return this._model;
    }

    brand() {
        return this._brand;
    }

    description() {
        return this._description;
    }

    licensePlate() {
        return this._licensePlate;
    }

    shortDescription() {
        return `${this.licensePlate() ? `${this.licensePlate()} - ` : ''}${this.brand()} - ${this.model()}`;
    }

    isActive() {
        return this._active;
    }

    company() {
        return this._company;
    }

    companyId() {
        return this.company().id();
    }

    companyDescription() {
        return this.company().description();
    }

    documentation() {
        return this._documentation;
    }

    documentationDescription() {
        return this.documentation().mySchemaDescription();
    }

    documentationStateData() {
        return this.documentation().stateData();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/machine/PsMachine.js